













import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderList extends Vue {
  private orderListTypes = orderListTypes.ORDER_LIST;
  private orderSearchTypes = focusTabName.DELIVERY_TAB;
  private includesHoldDelivery = true;
}
